import {ApolloClient} from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import {onError} from 'apollo-link-error';
import {setContext} from 'apollo-link-context';
import {HttpLink} from 'apollo-link-http';
import reportApolloError from './reportApolloError';
import appConfig from '../../appConfig';
import createApolloCache from './createApolloCache';

const client = (uri: string) => {
  const httpLink = new HttpLink({
    uri,
    credentials: 'include',
  });
  const headersLink = setContext((_request, {headers = {}}) => ({
    headers: {
      ...headers,
      'X-EZCATER-SERVICE-NAME': 'delivery-management-react',
      'X-EZCATER-SOURCE': 'client',
    },
  }));
  const errorLink = onError(reportApolloError);

  return new ApolloClient({
    cache: createApolloCache(),
    link: ApolloLink.from([errorLink, headersLink, httpLink]),
    name: 'delivery-management-react',
    connectToDevTools: appConfig.appEnvironment === 'development',
    version: appConfig.appBuildId,
  });
};

export default client(`${appConfig.graphqlHost}/graphql`);
